// extracted by mini-css-extract-plugin
export default {"viewerContainer":"ViewerComponent_viewerContainer__xbMRO"};